import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | failed | timeout

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      if (attempts > 8) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
      } catch {}
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="payment-success-page">
      <div className="max-w-md w-full bg-white rounded-3xl border border-[#dfd8da] shadow-xl p-10 text-center">
        {status === "checking" && (
          <>
            <Loader2 className="mx-auto animate-spin text-[#920e12]" size={40} />
            <h1 className="mt-4 font-display text-2xl text-[#550001]">Confirming your enrollment…</h1>
            <p className="mt-2 text-[#545454]">One moment while we verify your payment.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto text-[#15803d]" size={48} />
            <h1 className="mt-4 font-display text-2xl text-[#550001]">You're enrolled! 🎭</h1>
            <p className="mt-2 text-[#545454]">Your spot is confirmed. Head to your participant area to see your classes.</p>
            <Button asChild className="mt-6 bg-[#920e12] text-white" data-testid="success-portal-btn"><Link to="/participant">Go to my classes</Link></Button>
          </>
        )}
        {(status === "failed" || status === "timeout") && (
          <>
            <XCircle className="mx-auto text-[#991b1b]" size={48} />
            <h1 className="mt-4 font-display text-2xl text-[#550001]">{status === "timeout" ? "Still processing" : "Payment not completed"}</h1>
            <p className="mt-2 text-[#545454]">{status === "timeout" ? "Your payment is taking longer than expected. Check your participant area shortly." : "No charge was made. You can try again anytime."}</p>
            <Button asChild variant="outline" className="mt-6 border-[#920e12] text-[#920e12]"><Link to="/shop">Back to shop</Link></Button>
          </>
        )}
      </div>
    </div>
  );
}
